export default __webpack_public_path__ + "static/media/detail_big_4_5.8cbd02de.png";